module.exports = __webpack_public_path__ + "media/images/icons/outlined/frown-3d873f7d28bbd2dbca40da390532f3de.svg";